export function formatDateTime(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(dateStr: string): string {
  return new Date(dateStr).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Convert an ISO date string (`YYYY-MM-DD`) to `dd/MM/yyyy` for display — matches
 * what the `en-GB` DatePicker and native `<input type="date">` render, so a locked
 * (read-only) date field reads the same as an editable one. Passes through any
 * value that isn't a bare ISO date (already-formatted, empty, or non-date values).
 */
export function formatIsoDateDisplay(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : value;
}
